export var source_product_category_overview_tab = { "uid": "source_product_category_overview_tab", "fields": { "title": { "defaultValue": "" }, "cfh_id": { "defaultValue": "" }, "content": { "defaultValue": "" } } };
